import { config } from "../env";
import { get, post, postFileUpload } from "./helpers/http-handler";

export const dashboardUsereSummary = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/user/summary?${queryRequest}`);

export const dashboardExpenseTypeSummary = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/expense-type/summary?${queryRequest}`);

export const dashboardExpenseSummary = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/expense-report/summary?${queryRequest}`);

export const dashboardTripSummary = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/trip/summary?${queryRequest}`);

  export const dashboardProjectSummary = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/project/summary?${queryRequest}`);

  export const dashboardExpenseGraph = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/expense-graph/summary?${queryRequest}`);

  export const dashboardDepartmentSummary = (queryRequest: string) =>
  get(`${config.API_URL}/dashboard/department/summary?${queryRequest}`);
  
  export const dashboardReimbursementToken = (payload: object) =>
    post(`${config.API_URL}/stohrm-reimbursement-integration/generate-token`, payload);

  export const dashboardReimbursementSummary = (payload: object) =>
    post(`${config.API_URL}/stohrm-reimbursement-integration/reimbursement-type`, payload);

  export const dashboardReimbursementHistory = (payload: object) =>
    post(`${config.API_URL}/stohrm-reimbursement-integration/reimbursement-history`, payload);


  export const ctcReimbursementApplicationForm = (payload: object) =>
    post(`${config.API_URL}/stohrm-reimbursement-integration/application-form`, payload);

  export const ctcReimbursementApplicationFormSubmit = (payload: object) =>
    postFileUpload(`${config.API_URL}/stohrm-reimbursement-integration/reimbursement-submit`, payload);

  export const ctcReimbursementView = (payload: any) =>
    post(`${config.API_URL}/stohrm-reimbursement-integration/reimbursement-view`, payload);